import { render, staticRenderFns } from "./CustomerPartObsolescence.vue?vue&type=template&id=999f9164&scoped=true&"
import script from "./CustomerPartObsolescence.vue?vue&type=script&lang=ts&"
export * from "./CustomerPartObsolescence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999f9164",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
